<template>
  <div  class="div-aside"> 
    <div style="text-align: center;padding: 6px;background: rgba(0,0,0,0.06);">
      <img src="images/logomenu.svg" style="width:120px">
    </div>   
    <b-input-group size="sm">
      <b-form-input placeholder="Buscar en el menú"></b-form-input>
    </b-input-group>
    <div v-for="(items,index) in user.permisos_modulos" v-if="menuMovil[index]!==undefined" :key="'navPc'+index">      
        <span @click="openVisible=index;visible={};visible[index]=true" class="aside-title-span" style="text-transform:capitalize;bacground" :class="{'text-header' : namePath.includes(index+'_')}"><b-icon style="vertical-align: text-bottom;"   font-scale="1.3" :icon="icons[index]" aria-hidden="true"></b-icon> {{index}}</span>        
        <b-collapse v-model="visible[index]">
          <b-list-group>
            <b-list-group-item v-show="user.permisos_modulos[index][index2] && menuMovil[index][index2]!==undefined"  v-for="(items2,index2) in items"  :key="'listPc'+index2" style="border-right:none;padding: 0.4rem 1.25rem;text-transform:capitalize;font:size:15px" :href="'#/'+index+'/'+index2" :active="namePath===index+'_'+index2">- {{nameModule(index2)}} <b-icon icon="exclamation-diamond" v-if="namePath!==index+'_'+index2 && alertaPendientes[index+'_'+index2]" scale="1.2" variant="danger" style="float:right;margin: 3px -7px;display:none"></b-icon></b-list-group-item>    
          </b-list-group>
        </b-collapse>
    </div>   
        <b-list-group-item style="border:none" @click="logout"><b-button variant="outline-danger">Cerrar sesión</b-button></b-list-group-item>  
  </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  name: "blank-layout",
  data() {
    return {
      icons: {
        admin: 'gear',
        afiliacion: 'folder',
        aportes: 'card-checklist',
        informes: 'clipboard-data',
        archivo: 'receipt-cutoff',
        afiliado: 'person-lines-fill',
        alertas: 'alarm',
        servicios: 'bag'
      },
      menuMovil: {
        afiliacion: {
          nueva:  true,
          pendientes:  true,
          documentos:  true,
          inclusiones: true,
          informes:  true,
          registros:  true,
          descargar:  true,
        },     
        aportes: {
          registrar:  true,
          registros:  true,
          descargar:  true,
        },      
        alertas: {
          autorizar:  true,
          servicios: true,
        }
      },
      visible: { afiliacion:true},
      openVisible: false
    }
  },
  updated()
  {
    let modulo=this.namePath.split('_')
    if(this.visible[modulo[0]]===false && this.openVisible===false)
    {
      this.visible={}
      this.visible[modulo[0]]=true
    }
  },
  computed: {
    alertaPendientes()
    {
      return { 
        afiliacion_nueva: JSON.stringify(this.predeterminados['afiliacion_nueva'].datos_afiliado)!==JSON.stringify(this.dataForm['afiliacion_nueva'].datos_afiliado) || JSON.stringify(this.predeterminados['afiliacion_nueva'].info_afiliacion)!==JSON.stringify(this.dataForm['afiliacion_nueva'].info_afiliacion) || this.dataPost['afiliacion_nueva'].data.length>0 }
    },
    numerosPendientes() {
      return { afiliacion_pendientes: this.dataGet['afiliacion_pendientes'].data.length }

    }
  },
  methods: {
    ...mapActions({
        logout:     'authStore/logout',
    }),
    nameModule(name)
    {
      return name.replace('_', ' ')
    }
  }
};
</script>
<style>
.div-aside {
  background: white;
  position: fixed;
  width: 200px;
  height: 100%;
  border-right: 1px solid rgba(0, 0, 0, 0.125);
  overflow: auto;
  padding-bottom: 65px;
}
.aside-btn{
  border-radius: 0;
  background: #003152;
  border: none;
}
.aside-btn:focus, .aside-btn:hover, .aside-btn:not(:disabled):not(.disabled):active{
  background: #003152;
  border: none;
  box-shadow: none !important;
}
.collapse .list-group-item{
  cursor:pointer;
  border-radius: 0
}
.list-group-item:first-child{
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
.list-group-item:last-child{
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}
.list-group-item.active {
    background-color: #006FE6;
    border-color: #006FE6;
}
.aside-title-span.text-header{
 color: #006FE6 
}
.aside-title-span{
  background:rgba(0,80,166, 0.05);
  padding: 9px;
  display: block;
  color: #6c757d;
  font-weight: bold;
}
</style>
